module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-home-categories"
  }, [(_vm.loading) ? _c('Loader') : _c('ul', _vm._l((_vm.categories), function(category) {
    return _c('li', [_c('ForumCategoryPreview', {
      attrs: {
        "category": category
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0672b542!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ForumHomeCategories.vue
// module id = 1966
// module chunks = 2